import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppConfigService} from '../../core/config/app-config.service';
import {Employee} from '../../admin/models/employee.model';
import {ImportExcel} from '../../admin/models/importExcel.model';
import {AuthenticationService} from '../../core/authentication/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class AbsenceService {

    private readonly baseUrl;
    private header: any;

    constructor(private readonly httpClient: HttpClient,
                private readonly authenticationService: AuthenticationService,
                private readonly configService: AppConfigService) {
        this.baseUrl = configService.getConfig().baseUrl;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()};
    }

    /**
     * Shared get request method
     * @param api
     * @param urlTarget
     */
    getRequest(api: string, urlTarget: string) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.get<any>(url, {headers: this.header});
    }

    /**
     * Shared post request
     * @param api
     * @param urlTarget
     * @param data
     */
    postRequest(api: string, urlTarget: string, data: any) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.post<any>(url, data, {headers: this.header});
    }

    /**
     * save employee post request.
     * @param api
     * @param urlTarget
     * @param group
     * @param data
     */
    empPostRequest(api: string, urlTarget: string, group: any, data: any) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.post<Employee>(url + group, data, {headers: this.header});
    }

    /**
     * Shared put request
     * @param api
     * @param urlTarget
     * @param data
     */
    putRequest(api: string, urlTarget: string, data: any) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.put<any>(url, data, {headers: this.header});
    }

    /**
     * update employee request
     * @param api
     * @param urlTarget
     * @param group
     * @param data
     */
    empPutRequest(api: string, urlTarget: string, group: any, data: any) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.put<Employee>(url + group, data, {headers: this.header});
    }

    /**
     * Shared delete request
     * @param api
     * @param urlTarget
     */
    deleteRequest(api: string, urlTarget: string) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.delete<null>(url, {headers: this.header});
    }

    empTeamPutRequest(api: string, urlTarget: string, data: any) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        return this.httpClient.put<ImportExcel[]>(url, data, {headers: this.header});
    }

    downloadExcelPostRequest(api: string, urlTarget: string) {
        const url = api + urlTarget;
        this.header = {'Authorization': 'Bearer ' + this.authenticationService.getAccessToken()}
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + this.authenticationService.getAccessToken(),
                'Content-Type': 'application/json',
            }),
            responseType: 'blob' as 'json'
        }
        return this.httpClient.post<Blob>(url, "", httpOptions);
    }
}
